goog.provide('el8.print.prenatalFlowsheet');

goog.require('el8.data.physicians');
goog.require('el8.data.practices');
goog.require('el8.ptdata.patients');
goog.require('el8.ptdata.prenatalFlowsheets');
goog.require('el8.template.print.prenatalFlowsheet');
goog.require('el8.util.print');

// HACK WARNING!
//
// Requiring el8.ptdata.ptTags here since the correct location for the require
// in patients.js  breaks Closure deps ordering. See comments there.
//
// goog.require('el8.ptdata.ptTags');

// See printClinicalSummary for a similar module
el8.print.prenatalFlowsheet.init = function(spec) {
    el8.ptdata.currPatient = el8.ptdata.patients.create(spec.patient);
    el8.data.currUser.populate(spec.currUser);
    el8.ptdata.prenatalFlowsheets.create(spec.flowsheet);
    var practice = el8.data.practices.create(spec.practice);

    var flowsheet = el8.ptdata.prenatalFlowsheets.all()[0];

    $('.print-content').replaceWith(
        el8.template.print.prenatalFlowsheet.content({
            patient: el8.ptdata.currPatient.asSoyMap(),
            currUser: el8.data.currUser.asSoyMap(),
            flowsheet: flowsheet.asSoyMap(),
            practice: practice.asSoyMap()
        })
    );

    el8.util.print.pageSetup();
};
